<template>
    <div :class="'questio' + step + '-bg align-center'" v-if="idx === step - 1">
        <fieldset class="all-100">
            <legend>{{questionGroup.question}}
                <template v-if="questionGroup.questionHighlight">
                    <br><span class="tt-big">{{questionGroup.questionHighlight}}</span>
                </template>
            </legend>
            <div class="control-group">
                <fieldset class="all-100">
                    <div class="control-group" id="question">
                        <ul class="control unstyled column-group push-center">
                            <li class="all-50 small-100 medium-50 tiny-100 large-50" v-for="(answer, index) in questionGroup.answers" :key="index">
                                <input :id="'choices-' + index" v-on:click="nextStep(answer.value)" name="choices" :value="answer.value" type="checkbox">
                                <label :for="'choices-' + index">{{answer.label}} </label>
                            </li>
                        </ul>
                    </div>
                    <ProgressBar :current-step="step" :step-length="5"></ProgressBar>
                </fieldset>
            </div>
        </fieldset>
    </div>    
</template>

<script>
export default {
    name: "Question",
    props: {
        questionGroup: Object,
        step: Number,
        idx: Number,
        questionsLength: Number,
    },
    data() {
        return {
            selectedOption: null
        }
    },
    methods: {
        nextStep(value) {
            if(!value) {
                return;
            }
            
            if (this.step < this.questionsLength) {
                this.$emit("onNextStep", value);
            } else {
                this.$emit("onSubmit");
            }
        }
    }
};
</script>
<style lang="scss">
.answer-container{
    margin-top:10px;
}
</style>

